export default __webpack_public_path__ + "static/media/avatar_w.776f5c30.svg";